import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChecklistService } from '../../../../../services/checklist.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-add-edit-checklist-item',
  templateUrl: './add-edit-checklist-item.component.html',
  styleUrls: ['./add-edit-checklist-item.component.scss'],
})
export class AddEditChecklistItemComponent implements OnInit {
  @Input() checklistItem;
  @Output() close = new EventEmitter();
  public partnerID = 0;
  public editing: boolean = false;
  public loading: boolean = false;
  public saving: boolean = false;
  public controlTypeOptions: any = [
    {
      value: 'CHECKBOX',
      label: this.translate.instant('bikeshop.checklist.checkbox'),
    },
    { value: 'TEXT', label: this.translate.instant('bikeshop.checklist.text') },
    {
      value: 'RADIO',
      label: this.translate.instant('bikeshop.checklist.radio'),
    },
    {
      value: 'MULTILINETEXT',
      label: this.translate.instant('bikeshop.checklist.multilinetext'),
    },
    {
      value: 'TRAFFICLIGHT',
      label: this.translate.instant('bikeshop.checklist.traffic_light'),
    },
  ];
  public colourList = [
    '#151a2a',
    '#b8255f',
    '#db4035',
    '#e05194',
    '#ff9933',
    '#fad000',
    '#afb83b',
    '#7ecc49',
    '#299438',
    '#158fad',
    '#14aaf5',
    '#4073ff',
    '#884dff',
    '#af38eb',
  ];

  constructor(
    public translate: TranslateService,
    private helpersService: HelpersService,
    private checklistService: ChecklistService,
    public confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.editing = this.checklistItem.id;
  }

  valid() {
    return this.checklistItem.description && this.checklistItem.controlType;
  }

  delete() {
    this.confirmationService.confirm({
      key: 'add_edit_checklist',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant('general.confirm'),
      message: this.translate.instant(
        'bikeshop.checklist.delete_checklist_item',
      ),
      accept: () => {
        this.saving = true;
        this.checklistService
          .deleteChecklistItem(this.partnerID, this.checklistItem.id)
          .subscribe(
            (res) => {
              this.saving = false;
              this.close.emit();
            },
            (err) => {
              this.saving = false;
            },
          );
      },
    });
  }

  save() {
    if (this.checklistItem.id) {
      this.updateChecklistItem();
    } else {
      this.addChecklistItem();
    }
  }

  addChecklistItem() {
    this.saving = true;
    this.checklistService
      .addChecklistItem(this.partnerID, this.checklistItem)
      .subscribe(
        (res) => {
          this.checklistItem = res;
          this.saving = false;
          this.close.emit();
        },
        (err) => {
          this.saving = false;
        },
      );
  }

  updateChecklistItem() {
    this.saving = true;
    this.checklistService
      .updateChecklistItem(this.partnerID, this.checklistItem)
      .subscribe(
        (res) => {
          this.checklistItem = res;
          this.saving = false;
          this.close.emit();
        },
        (err) => {
          this.saving = false;
        },
      );
  }
}
